import { HttpClient, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { loginComRetorno } from '../auth.guard';

// withXsrfConfiguration() do Angular não funciona com withFetch() — a Fetch API
// não expõe cookies ao interceptor built-in, por isso extraímos o token manualmente.
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const router = inject(Router);
  const auth = inject(AuthService);
  const http = inject(HttpClient);

  const attach = (request: HttpRequest<unknown>) =>
    request.clone({
      withCredentials: true,
      setHeaders: {
        Accept: 'application/json',
        ...(getCookie('XSRF-TOKEN') ? { 'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')! } : {}),
      },
    });

  const isRetry = req.headers.has('X-Retry-Csrf');

  return next(attach(req)).pipe(
    catchError((error) => {
      if (error.status === 419 && !isRetry) {
        // Cookie CSRF/sessão desatualizado no navegador: busca um novo e reenvia uma vez.
        return http
          .get(`${environment.apiUrl}/sanctum/csrf-cookie`, { responseType: 'text' })
          .pipe(
            switchMap(() => next(attach(req.clone({ setHeaders: { 'X-Retry-Csrf': '1' } })))),
            catchError((retryError) => {
              if (!req.url.includes('/login')) {
                auth.limparSessao();
                router.navigateByUrl(loginComRetorno(router));
              }
              return throwError(() => retryError);
            }),
          );
      }
      if ((error.status === 401 || error.status === 419) && !req.url.includes('/login')) {
        auth.limparSessao();
        router.navigateByUrl(loginComRetorno(router));
      }
      return throwError(() => error);
    }),
  );
};

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : null;
}
